// Eighty Days super-admins.
//
// One doc per admin, keyed by the Firebase Auth uid. Presence of the doc is the
// whole permission — there is no role field, and the security rules check the
// same thing the client does.
//
// Membership is managed in the Firebase console, deliberately: granting CMS
// access is the highest privilege in the system, and a UI for it would be a
// privilege-escalation path guarded by nothing but the same privilege. The
// accounts page lists admins read-only.

// Firestore collection name.
export const coll_admins = 'admins';

export interface AdminUserType {
  id: string; // === Firebase Auth uid

  // Written by whoever created the doc, so it may be missing on admins added
  // by hand in the console. The accounts page falls back to the uid.
  email?: string;
}
